import {
  IDashboardState,
  ISelectedCompany,
  ICompany,
} from "@/apps/dashboard/models/IDashboardState";

/**
 * MUTATIONS
 */
const mutations = {
  SET_FIRST_NAME: (state: IDashboardState, payload: string | null): void => {
    state.user.firstName = payload;
  },
  SET_LAST_NAME: (state: IDashboardState, payload: string | null): void => {
    state.user.lastName = payload;
  },
  SET_PHONE: (state: IDashboardState, payload: string | null): void => {
    state.user.phone = payload;
  },
  SET_EMAIL: (state: IDashboardState, payload: string | null): void => {
    state.user.email = payload;
  },
  SET_LOCALE: (state: IDashboardState, payload: string | null): void => {
    state.user.locale = payload;
  },
  SET_SELECTED_COMPANY: (
    state: IDashboardState,
    payload: ISelectedCompany
  ): void => {
    state.user.selectedCompany = payload;
  },
  SET_USER_REQUIRES_TWO_FACTOR: (
    state: IDashboardState,
    payload: boolean | null
  ): void => {
    state.user.userRequiresTwoFactor = payload;
  },
  SET_TWO_FACTOR_ENRROLED: (
    state: IDashboardState,
    payload: boolean | null
  ): void => {
    state.user.twoFactorEnrolled = payload;
  },
  SET_EMAIL_HASH: (state: IDashboardState, payload: string | null): void => {
    state.user.emailHash = payload;
  },
  SET_COMPANIES: (state: IDashboardState, payload: ICompany[] | null): void => {
    state.user.companies = payload;
  },
  CLEAR_USER_DATA: (state: IDashboardState): void => {
    // Reset user state to initial values
    state.user.firstName = null;
    state.user.lastName = null;
    state.user.phone = null;
    state.user.email = null;
    state.user.locale = null;
    state.user.selectedCompany = {
      companyId: null,
      companyName: null,
      country: null,
      roles: [],
    };
    state.user.userRequiresTwoFactor = null;
    state.user.twoFactorEnrolled = null;
    state.user.emailHash = null;
    state.user.companies = null;
  },
};

export default mutations;
